export default function formatResponseError(errors) {
  return errors?.map(error => error.title) || [];
}
